export default "__VITE_ASSET__DYWU2Cn___"